import { Account } from "@/models/Account";
import Toast from "@/plugins/Toast";
import { ToastType } from "@/types/toast";
import { inject, ref } from "vue";

export default class AccountsDialogViewModel {
  public toast: Toast;
  public dialog = ref(false);
  public accounts = ref<Account[]>([]); // Aquí se almacenan los datos de las cuentas

  constructor() {
    this.toast = inject("toast") as Toast;
  }

  /**
   * Método para abrir el diálogo y setear los datos
   * @param accountsData - Lista de cuentas a mostrar
   */
  public openDialog(accountsData: Account[]) {
    console.log("open dialog");
    this.accounts.value = accountsData; // Seteamos las cuentas
    this.dialog.value = true; // Mostramos el diálogo
  }

  /**
   * Método para copiar los datos de una cuenta
   * @param account - Cuenta seleccionada
   */
  public copyAccount(account: Account) {
    const text = `${account.nom_banco}\nCuenta: ${account.numcuenta}`;
    navigator.clipboard.writeText(text).then(() => {
      console.log("Datos copiados al portapapeles");
    });
    this.toast.showToast(
      "Cuenta copiada en el portapapeles. Ctrl + V para pegar el contenido",
      ToastType.Success
    );
    this.closeDialog();
  }
  public closeDialog() {
    this.dialog.value = false;
  }
}
